var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserType4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5663 8.49208C13.5663 8.08732 13.2378 7.75928 12.833 7.75928H1.21425C0.809485 7.75928 0.481445 8.08732 0.481445 8.49208V8.95795H1.38562V13.8138C1.38562 14.4147 1.87263 14.9008 2.47219 14.9008H11.5976C12.1985 14.9008 12.6841 14.4133 12.6841 13.8138V8.95749H13.5663V8.49208Z",
    fill: "#0078E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.79204 5.77022H10.4518C10.936 5.77022 11.3293 5.37234 11.3293 4.88855V1.05959C11.3293 0.669064 11.0091 0.352051 10.6177 0.352051C10.2262 0.352051 9.90506 0.669064 9.90506 1.05959V4.34641H9.2816C9.11023 4.23339 8.90624 4.16585 8.68571 4.16585H5.3704C4.75705 4.16585 4.25488 4.67216 4.25488 5.28551V7.03597H9.79204V5.77022Z",
    fill: "#0078E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.02759 3.53345C7.90604 3.53345 8.61817 2.82133 8.61817 1.94287C8.61817 1.06442 7.90604 0.352295 7.02759 0.352295C6.14914 0.352295 5.43701 1.06442 5.43701 1.94287C5.43701 2.82133 6.14914 3.53345 7.02759 3.53345Z",
    fill: "#0078E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserType4);
export default __webpack_public_path__ + "static/media/UserType4.0db62a36c0ad8e7ab9982fd57004dfc3.svg";
export { ForwardRef as ReactComponent };